import { IGuideInfoData } from "@/domain/entities/guide";
import { useGuideStore } from "@/stores/guideStore";
import { ref } from "vue";

export const useGetGuideInfoOnLogout = () => {
  const guideStore = useGuideStore();

  const guideInfo = ref<IGuideInfoData>();

  const getGuideInfoOnLogout = async () => {
    const guideInfosResult = await guideStore.getGuideInfosOnLogout();
    if (!guideInfosResult.isSuccess) return;

    guideInfo.value = guideInfosResult.data?.length
      ? guideInfosResult.data[0]
      : undefined;
  };

  return { guideInfo, getGuideInfoOnLogout };
};
